import Swal from 'sweetalert2'
import { useContext, useEffect, useState } from 'react';

import CenterContext from 'context/CenterContext';
import {
    getAll,
    create,
    update,
    del
} from "services/CenterService.js";

let totalPages;

export function useCenter() {
    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5)

    const {
        allCenters,
        setAllCenters,
        centers,
        setCenters,
        message,
        setMessage,
        loading,
        setLoading
    } = useContext(CenterContext);

    const getAllCenters = async ({ codeCenter, name, openingHours, direction, pickUpOnPoint, isCenter }) => {
        try {
            const response = await getAll({ codeCenter, name, openingHours, direction, pickUpOnPoint, isCenter });
            setAllCenters(response)
            return response
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
        }
    }

    const getCenters = async ({ page = 1, limit = itemsPerPage, codeCenter, name, openingHours, direction, pickUpOnPoint, isCenter }) => {
        setLoading(true);
        setPage(page);
        try {
            const allCenters = await getAllCenters({ codeCenter, name, openingHours, direction, pickUpOnPoint, isCenter });
            setAllCenters(allCenters);
            totalPages = Math.ceil(allCenters.length / limit)
            const centers = await getAll({ page, limit, codeCenter, name, openingHours, direction, pickUpOnPoint, isCenter });
            setCenters(centers);
            setLoading(false);
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
            setLoading(false);
        }
    }


    const createCenter = async ({ center }) => {
        try {
            const { message } = await create({ center })
            setMessage(state => ({ ...state, message }))
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            getCenters({ page })
            return ''
        } catch (err) {
            const { data, status } = err.response
            setMessage({ message: data.message, status })
            return status
        }
    }

    const updateCenter = async ({ center, id }) => {
        try {
            const { message } = await update({ center, id })
            setMessage({ message: '', status: 200 })
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            getCenters({ page })
            return ''
        } catch (err) {
            const { data, status } = err.response
            setMessage({ message: data.message, status })
            return status
        }
    }

    const deleteCenter = async ({ id }) => {
        Swal.fire({
            title: 'Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                (async () => {
                    try {
                        const { message } = await del({ id })
                        setMessage({ message: '', status: 200 })

                        Swal.fire(
                            'Éxito!!!',
                            message,
                            'success'
                        )
                        getCenters({ page })
                    } catch (err) {
                        const { data, status } = err.response
                        setMessage({ message: data.message, status })
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: data.message,
                        })
                    }
                })();
            }
        })
    }

    useEffect(() => {
        getCenters({});
        // eslint-disable-next-line
    }, [])

    return { allCenters, centers, page, totalPages, status: message.status, loading, deleteCenter, updateCenter, createCenter, getCenters, setPage, itemsPerPage, setItemsPerPage }
}